import { InputAdornment, TextField } from "@mui/material";
import {
    ReactElement,
    HTMLAttributes,
    useState,
    useEffect,
    useRef
} from "react";
import { Cancel, DangerSquare , Star } from "../../assets";
import { fixNumbers, numberWithCommas } from "../../core/utils";
interface Props extends HTMLAttributes<HTMLElement> {
    value?: string | number;
    title?: string,
    onChange?: any;
    myStyle: string;
    icon?: ReactElement;
    customFocus?: any;
    lable?: string;
    disabled?: boolean;
    error?: string;
    type?: string;
    emptyState?: any;
    max?: string;
    placeholder?: string;   
    endAdornment?: string;
    isRequired?:boolean;
    hideEndAdornment?:boolean;
    iconBorder?: boolean;
    hasNotice?: boolean;
    hasComma?: boolean;
    contentLoading?:boolean;
}

export function Input({ value, onChange, title, myStyle, icon, customFocus, lable, disabled, error, type, emptyState, hasComma, max, placeholder, iconBorder, endAdornment, isRequired, hideEndAdornment, hasNotice , contentLoading }: Props, props: any): ReactElement {
    let inputRef : any = useRef(null);
    const [shrink, setShrink] = useState(false);
    const [selectionStart, setSelectionStart] = useState();
    const updateSelectionStart = () =>
    setSelectionStart(inputRef.current.selectionStart);

    const setFoces = () => {
        setShrink(true)
        // customFocus && customFocus()
    }

    useEffect(() => {
        if (value === "") setShrink(false)
        if (value !== "")
            // textInput.current.focus();
            setFoces();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const handleOnChange = (e: any) => {
        // if (type === "number") {
        //     if (e.target.value === "" || numberRegexp.test(e.target.value)) {
        //         onChange(e)
        //     }
        // } else {
        //     onChange(e)
        // }
        const re = /^[0-9\b]+$/;
        let checkLength = new RegExp(`^\\d{0,${max ? max : "255"}}$`);
        let inputValue = fixNumbers(e.target.value);    
        if (type === "number" && hasComma) {
            if (hasComma) {
                let val = inputValue.replace(/,/g, '');
                if ((val === "" || re.test(val)) && checkLength.test(val)) {
                    
                    onChange(val)

                }
            } 
        } else if (type === "number" && !hasComma){
            if ((inputValue === "" || re.test(inputValue)) && checkLength.test(inputValue)) {
                onChange(e)
            }
        }else if(type !== "number") {
            

            onChange(e)
        }else{

        }
    }
    const showValue = (e: any) => {
        if (type === "number") {
            if (e !== "") {
                if (hasComma) {
                    return numberWithCommas(e)
                } else {
                    return e
                }
            }
        } else {
            return e
        }
    }

    // useEffect(() => {
    //     if (inputRef.current) {
    //       inputRef.current.focus();
    //       inputRef.current.selectionStart
    //     //   inputRef.current.setSelectionRange(startCursorPosition, startCursorPosition);
    //     }
    //   }, [selectionStart]);
    return (

        <div className={`${myStyle && myStyle} custom-input`} >
           {lable &&
                  <>
                    {contentLoading ?
                        <div className="input-loading-lable content-loading">
                        </div>
                        :

                <label className="custom-input-lable">
                  {isRequired && <img src={Star} alt="هامرز"/>}  {lable}  {hasNotice &&  <img src={DangerSquare} alt="هامرز"/> }
                </label>

               
}
</>
}

{contentLoading ? <div className="content-loading w-100">
            </div> :
            <TextField
                autoComplete="off"
                className="input"
                error={error ? true : false}
                onFocus={() => customFocus ? customFocus() : setFoces()}
                value={showValue(value)}
                // onChange={(e)=>onChange(e.target.value)}
                onChange={handleOnChange}
                disabled={disabled}
                inputRef={inputRef} 
                // onFocus={updateSelectionStart}
                onBlur={(e) => setShrink(!!e.target.value)}
                InputLabelProps={{ sx: icon ? { ml: 4.5 } : null, shrink }}
                sx={(theme) => ({
                    "& .MuiOutlinedInput-notchedOutline": {
                        px: icon ? 5.5 : ""
                    }
                })}
                // onInput={(e:any) => {
                //     e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12);
                //   }}
                //   InputProps={{ inputProps: { min: "0", max: "10", step: "1" } }}
                inputProps={{
                    maxLength: max ? max : "255",
                }}
                type="string"
                label={title && title}
                placeholder={placeholder && placeholder}

                InputProps={{
                    startAdornment: icon ? (
                        <InputAdornment position="start" >
                            {icon}
                            {iconBorder &&
                                <div className="custom-input-icon-border">
                                </div>
                            }
                        </InputAdornment>
                    ) : null,
                    endAdornment:  (value && !hideEndAdornment) ? (
                        <InputAdornment position="end" onClick={emptyState} className="custom-input-cancel">
                            {<Cancel width="10px" color="#155a9e" myStyle="cursor-pointer" />}
                        </InputAdornment>
                    ) : endAdornment ? (<span>
                        {endAdornment}
                    </span>
                    ) : ""
                }}
                variant="outlined"
            />
}
            {error &&
                <label className="custom-input-error">
                    {error}
                </label>
            }
        </div>

    );
}

export default Input;